import { useField } from 'formik';
import React from 'react';
import { match } from 'ts-pattern';
import { Textarea } from 'ui-components';

export const ProfileBio = () => {
  const [field] = useField('bio');

  return (
    <div className="space-y-2">
      <Textarea
        name="bio"
        label="Bio"
        placeholder="Tell us about yourself..."
        maxLength={550}
        track-id="foam-profile-settings--bio"
        rows={4}
      />
      <p className="px-3 text-root-size-body-lg text-form-base-helper-color">
        {match(field.value)
          .with('', () => 'Max. 550 characters')
          .otherwise(() => `${field.value.length}/550 characters`)}
      </p>
    </div>
  );
};
